import axios from 'axios';

const isLocal = window.location.origin.includes('localhost');
const localUrl = 'http://localhost:5001/jedeadmin/us-central1/app';
const globalUrl = 'https://us-central1-jedeadmin.cloudfunctions.net/app';

const apiPath = isLocal ? localUrl : globalUrl;
// axios post call to  /api/gamefy/randomReward
export async function randomReward(params) {
  const response = await axios.post(`${apiPath}/api/gamefy/randomReward`, { ...params, points: 5 });
  return response;
}
export async function newApiKey(userId) {
  const response = await axios.post(`${apiPath}/api/gamefy/new`, { userId });
  return response;
}

export async function getApiKey(userId) {
  const response = await axios.get(`${apiPath}/api/gamefy/getApiKey/${userId}`);
  return response;
}

export async function getPoints({ userId }) {
  const response = await axios.get(`${apiPath}/api/gamefy/points/${userId}`);
  return response;
}

export async function addPoints({ userId, points, apiKey }) {
  const response = await axios.post(`${apiPath}/api/gamefy/addPoints`, { userId, points, apiKey });
  return response;
}

export async function addReward({ userId, reward, apiKey }) {
  const response = await axios.post(`${apiPath}/api/gamefy/addReward`, { userId, reward, apiKey });
  return response;
}

export async function getRewards({ userId, apiKey }) {
  const response = await axios.post(`${apiPath}/api/gamefy/getRewards`, { userId, apiKey });
  return response;
}

export async function removeReward({ userId, rewardId, apiKey }) {
  const response = await axios.post(`${apiPath}/api/gamefy/removeReward`, { userId, rewardId, apiKey });
  return response;
}

export async function getListOfWinRewards({ userId, apiKey }) {
  const response = await axios.post(`${apiPath}/api/gamefy/getListOfWinRewards`, { userId, apiKey });
  return response;
}

export async function removeRewardFromListOfWinRewards({ userId, rewardId, apiKey }) {
  const response = await axios.post(`${apiPath}/api/gamefy/removeRewardFromListOfWinRewards`, { userId, rewardId, apiKey });
  return response;
}
